import store from 'util/data/store';
import round from 'util/numbers/round';
import isMetric from 'util/numbers/is-metric';
import measure from 'legacy/util/numbers/measure';
import formModel from 'models/form-model';

export default function(control, assetId) {
    const properties = store.assets[assetId].properties,
        metric = isMetric(),
        asset = store.assets[assetId];
    let value = properties[control.fieldName];
    value = round(metric ? value : measure.cubicMetersToCubicYards(value));
    if (formModel.isReadOnlyControl(asset.assetTypeId, control)) {
        return <div class="eval-value">{value} {metric ? 'meters³' : 'feet³'}</div>;
    }
    return <div class="area-control">
        <input data-focus-id="1"  type="number" class="number-input" value={value} step="any" oninput={e => {
            formModel.handleVolume(e, control, assetId);
        }}/>
        <span class="number-metric">{metric ? 'meters³' : 'yards³'}</span>
    </div>;
}
